export const EVENT_PAYMENT_ORDER_UPDATE = 'paymentOrder.update'
export const EVENT_PAYMENT_ORDER_CREATE = 'paymentOrder.create'
